// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../node_modules/.pnpm/html-loader@4.2.0_webpack@5.107.2/node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("/assets/img/loading-bicycle.gif");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"infinite-scroll\">\n    <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\">\n</div>\n";
// Exports
module.exports = code;